import { NgZone } from '@angular/core';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import { SearchConfigService } from '../../search-results/services/search-config.service';
import { CreateDocumentService } from '../../shared/services/create-document.service';
import { DeviceDetector } from '../../shared/services/device-detector.service';
import { OfficeRouteItem, OfficeRouteService } from '../../shared/services/office-route.service';
import { UrlLauncherService } from '../../shared/services/url-launcher.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { LocService } from '../../shared/shared-context/loc.service';
import { SearchInstrumentationService } from '../search-instrumentation.service';
import { SharedSearchService } from '../shared-search.service';

export class BaseSuggestionProvider {
    public static capabilitiesService: CapabilitiesService;
    public static clientStartupConfigService: ClientStartupConfigService;
    public static contextService: ContextService;
    public static createDocumentService: CreateDocumentService;
    public static currentRoute: OfficeRouteItem;
    public static deviceDetector: DeviceDetector;
    public static isDarkMode: boolean;
    public static locService: LocService;
    public static ngZone: NgZone;
    public static officeRouteService: OfficeRouteService;
    public static searchConfigService: SearchConfigService;
    public static searchInstrumentationService: SearchInstrumentationService;
    public static sharedSearchService: SharedSearchService;
    public static shellShim: IO365ShellShim;
    public static urlLauncherService: UrlLauncherService;
}
